<template>
  <div class="WapFrontPage">
    <div class="page">
      <div class="plogo">
      <logo :logo="logo" :inputStyle="{width:'30vw'}"></logo>
      </div>
      <div class="ptitle">
        <my_title :title="title"></my_title>
      </div>
      <div class="pbutton" @click="login()" v-if="!user">登录</div>
      <div class="pbutton" @click="myPage()" v-else>我的成绩</div>
      <div class="tips">
        PC 端打开aishiqingsai.org.cn
        <br>
        注册账号进行比赛
      </div>
    </div>
    <div class="rank">
      <head_line :title="'全国战力榜 - POWER RANKINGS'"></head_line>
      <div class="group">
          <div class="bt" :class="{focus: fcg==g.key}" v-for="g in groups" @click="focus(g.key)">{{g.text}}</div>
      </div>
        <div class="hd">
          <div class="img">排名</div>
          <div>名称</div>
          <div>战力积分</div>
          <div>战区</div>
        </div>
 
      <rank_list :ranks="info"></rank_list>
      <div class="bbutton" @click="rankMore()">查看更多</div>
    </div>
    <!-- <div class="about">
         <head_line :title="'活动介绍 - ABOUT'"></head_line>
         <my_video :v="v" :inputStyle="{width: '85vw',height: '50vw'}"></my_video>
         </div> -->

    <div class="organizer">

      <head_line :title="'主办方 - ORGANIZER'"></head_line>
      <div class="logos">
        <logo :logo="logos.kdxt" :inputStyle="{width:'25vw'}"></logo>
        <logo :logo="logos.coco"  :inputStyle="{width:'26vw'}"></logo>
        <logo :logo="logos.tulingWhite"  :inputStyle="{width:'24vw'}"></logo>
      </div>
    </div>
    <div class="contact">
      <head_line :title="'联系我们 - CONTACT'"></head_line>
        <img alt="" :src="logos.img_coco" class="qr" />
    </div>
    <div class="page page2">
      <div class="ptitle">
        <my_title :title="{main:'AI算法天梯, 等你来战'}"></my_title>
      </div>
    </div>
  </div>
</template>

<script>
 // @ is an alias to /src
 import Logo from '@/components/Logo.vue';
 import Title from '@/components/wapfrontpage/Title.vue'
 import Headline from '@/components/wapfrontpage/Headline.vue'
 import RankList from '@/components/waprank/rankList.vue'
 import MyVideo from '@/components/Video.vue';

 export default {
   name: 'WapFrontPage',
   computed: {
     logo () {
       return this.$store.state.logo.main
     },
     logos () {
       return {
         kdxt: this.$store.state.logo.kdxt,
         coco: this.$store.state.logo.coco,
         tulingWhite: this.$store.state.logo.tulingWhite,
         img_coco: '/oss/images/bottombar/coco-qr.png',
       }
     },
 
     v() {
       return this.$store.state.frontpage.videos[0]
     },
     groups() {
       return this.$store.state.enroll.groups
     },
     user () {
       return this.$store.state.auth.user
     },
    title() {
      return this.$store.state.frontpage.title
    },
     indexOfGroup() {
       return {
         s: 1,
         m: 2,
         l: 3
       }
     }
   },
   data() {
     return {
       fcg: 's',
       info: []
     }
   },
   methods: {
     login() {
       this.$router.push({name: 'account', params: {type: 'login'}})
     },
     myPage() {
       
       this.$router.push({name: 'WapSharePage'})
     },
     rankMore() {
       this.$router.push({name: 'waprankpage'})
     },
     focus(c) {
       this.fcg =c
       this.fetchData()
     },
     fetchData() {
      let round = this.$store.state.game_year + '-1';
       let group = this.indexOfGroup[this.fcg];
       let uri = '/api/rank/?group='+group;
       this.$http.get(uri)
           .then(res => {
             this.info = res.data.slice(0,5).map(d=>
               {return {rank:d.rank,
                        name:d.username,
                        score: d.score,
                        area:d.area_name.split(' ')[0]}})
           })
 
  
     }

   },
   mounted () {
     this.fetchData();
       },
   components: {

     my_video: MyVideo,
     logo: Logo,
     my_title: Title,
     head_line: Headline,
     rank_list: RankList
   }
 }
</script>
<style scoped>
 .WapFrontPage{
   min-height: 100vh;
   background-image: url('/oss/images/static-page/out.jpg');
   background-position: -10vw 7.5vh;
   background-size: auto 60vh;
   /* background-repeat: no-repeat; */
 }
 .page {
   background: linear-gradient(to bottom, rgba(0, 0, 0, 1) 10%,   rgba(0,0,0, 0.4) 40%,   rgba(0,0,0, 0.4) 60%,   rgba(0,0,0, 1) 90%);
   min-height: 75vh;
   display: flex;
   flex-direction: column;
   align-items:center;
 }
 .page2{
   min-height: 45vh !important;
 }
 .ptitle {
   /* height: 30vh; */
   margin-top: 12vh;
 }
 .pbutton{
   width: 24vw;
   font-size: 4vw;
   line-height: 10vw;
   color: white;
   background-color: var(--blue);
   border-radius: 5px;
   text-align: center;
   margin-top: 6vh;
 }
 .plogo {
   display: flex;
   width: 100vw;
   align-items:center;
  justify-content:center;
   padding-top: 5vh;
 }
 .tips{
   color: rgba(255,255,255,0.9);
   font-size: 4.5vw;
   margin-top: 2vh;
   text-align: center;
 }
 .about, .organizer, .contact{
   background-color: rgba(0,0,0,1);
   padding-top: 5vh;
   display: flex;
   flex-direction:column;
   align-items:center;
 }
 .rank{
   background-color: rgba(0,0,0,1);
   min-height: 25vh;
   display: flex;
   flex-direction:column;
   align-items:center;
 }
 .about{
   /* height: 50vw; */
 }

 .group{
   display: flex;
   align-items:center;
   justify-content:center;
 }
.group .bt{
   width: 25vw;
   height: 7.35vw;
   font-size: 3vw;
   line-height: 7.35vw;
   background-image: url(/oss/images/wap/rank/button-other.png);
   background-size: 25vw;
   background-repeat: no-repeat;
   background-position: center;
   margin: 1px;
   text-align:center;
 }
 .group .bt.focus{
   background-image: url(/oss/images/wap/rank/button-light.png);
   color: rgba(240,240, 240, 0.8);
 }
 .bbutton{
   width: 8em;
   font-size: 4vw;
   line-height: 10vw;
   color: white;
   background-color: var(--blue);
   border-radius: 5px;
   text-align: center;
   margin-top: 3vh;
  color: white;
 }

 .hd{
      width: 90vw;
   display: flex;
   height: 40px;
   font-size: 14px;
   align-items:center;
   justify-content:space-around;
   color: rgba(200, 200, 200, 0.6);
 }

 .img  {
   flex-basis: 50px;
 }
 
 .logos{
   display: flex;
   align-items: center;
   justify-content:space-around;
   width: 90vw;
 }
 .qr{
   width: 30vw;
   height: 30vw;
 }
</style>
